import type { CSSProperties } from 'react'
import { useState } from 'react'
import EasyIcon from './EasyIcon'

const PasswordLabel = (props: {
  text: string,
  letterCounts?: number,
  className?: string,
  style?: CSSProperties
}) => {
  const [visible, setVisible] = useState(false)
  return (
    <div onClick={() => setVisible(!visible)} className={props.className} style={props.style}>
      <span>{visible ? props.text : props.text.replace(/./g, '*').slice(0, props.letterCounts || props.text.length)}</span>
      <EasyIcon
        type={visible ? 'EyeInvisibleOutlined' : 'EyeOutlined'}
        className='cursor-pointer pd-l8'
      />
    </div>
  )
}

export default PasswordLabel